<template lang="pug">
data-handler(
  ref="requirementsForm"
  v-model="requirementsList"
  :method="getEventUserRequirements"
  :serialize-data="(resp) => resp.items"
  :no-init="!canGetNominationRequirements || hide"
)
  template(#default="{ loading }")
    api-form(
      v-model="formData"
      :fields="visibleFields"
      :method="save"
      :success-callback="successCallback"
      no-reset
    )
      template(#save-btn="props")
        .mt-3.d-flex.justify-center
          app-button(
            v-if="!hide"
            :loading="props.loading"
            :disabled="props.invalid || !hasChanges || loading"
            rounded
            @click="props.action"
          ) Сохранить
          slot(
            name="actions"
            v-bind="{ ...props, invalid: (props.invalid || hasChanges || loading) && !hide }"
          )
</template>

<script>
/* eslint-disable indent */
import UserRequirementsForm from './UserRequirementsForm.vue';
import UserAttributes from '@/modules/Profile/components/UserAttributes.vue';
import { deepObjectMerge } from '@/modules/UserEventLanding/functions';
import { PER_PAGE } from '@/constants/pagination';
import { EVENT_ATTRIBUTES_TYPES } from '@/modules/UIDesign/Events/components/EventRequirements/constants';

// Экспериментальный компонент
// Совмещает в себе две формы (Поля пользователя и Атрибуты)
// Возможно, в дальнейшем сделать одну единую форму гибкую для удобства
// Пока что работает чисто на записи на мероприятие

export default {
  components: {
    UserRequirementsForm,
    UserAttributes,
  },
  props: {
    event: {
      type: Object,
      default: undefined,
    },
    additionalFields: {
      type: Array,
      default: () => [],
    },
    fieldsSettings: {
      type: Object,
      default: undefined,
    },
    nominations: {
      type: Array,
      default: undefined,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    hide: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: this.value,
      nestedMethods: {},
      requirementsList: undefined,

      hasRequirementsChanges: false,
      hasAttributesChanges: false,
    };
  },
  computed: {
    // TODO: поговорить с бэком, изменить формат вывода requirements
    // Сделать так 'field_name: { required: true }'
    // field: options<Object>
    requirementsSettings() {
      const { requirementsList, event, nominations } = this;
      const convertFields = (key) => {
        const last = -1;
        const regex = /^(.+?)(?:_id)?$/;
        const match = key.match(regex);
        return match.at(last);
      };
      const nominationIds = nominations.length >= event.nominations.length
        ? [] : nominations.map(({ id }) => id);
      const currentList = (requirementsList || [])
        .filter(({ isSystem }) => isSystem)
        .filter((item) => nominationIds?.length ? (nominationIds.some((id) => item.isAssigned(event.id, id)) || item.isGlobal(event.id)) : item.isGlobal(event.id));
        // .filter((item) => this.showAttributes ? item.type === EVENT_ATTRIBUTES_TYPES.class : item.type !== EVENT_ATTRIBUTES_TYPES.class);

      return Object.fromEntries(currentList.filter(({ options }) => options.assign).map((item) => ([
        convertFields(item.options.assign),
        { required: item.assignRequired(event, null), variants: item.options.variants || [] },
      ])));
    },

    hasChanges() {
      return this.hasRequirementsChanges || this.hasAttributesChanges;
    },
    canGetNominationRequirements() {
      return !!this.nominations?.length || !!this.event;
    },
    groupsDirectoryAttributes() {
      if (!this.nominations) {
        return undefined;
      }

      return this.nominations
        .flatMap((i) => i.selected_groups)
        .flatMap((i) => i?.directory_attributes)
        .map((i) => i?.directory_id);
    },
    extendFieldsSettings() {
      const { fieldsSettings, requirementsSettings, hide } = this;

      if ((!fieldsSettings && !requirementsSettings) || hide) {
        return undefined;
      }

      return {
        ...fieldsSettings,
        ...requirementsSettings,
      };
    },
    fields() {
      const { groupsDirectoryAttributes, extendFieldsSettings, additionalFields, nestedMethods } = this;

      return [
        ...(this.extendFieldsSettings
          ? [
              {
                value: 'requirements',
                component: UserRequirementsForm,
                component_attrs: {
                  fields: extendFieldsSettings,
                  hideSave: true,
                },
                component_events: {
                  init: ({ method }) => {
                    this.$set(nestedMethods, 'requirements', method);
                  },
                  hasChanges: (val) => {
                    this.hasRequirementsChanges = val;
                  },
                  fieldsData: (val) => {
                    this.$emit('fieldsData', val);
                  },
                },
              },
            ]
          : []),
        // {
        //   value: 'attributes',
        //   hidden: !groupsDirectoryAttributes?.length,
        //   component: UserAttributes,
        //   component_attrs: {
        //     toplabel: false,
        //     accessDirectories: groupsDirectoryAttributes,
        //   },
        //   component_events: {
        //     init: ({ method }) => {
        //       this.$set(nestedMethods, 'attributes', method);
        //     },
        //     hasChanges: (val) => {
        //       this.hasAttributesChanges = val;
        //     },
        //   },
        // },
        ...additionalFields,
      ];
    },
    visibleFields() {
      return this.fields.filter((i) => !i.hidden);
    },
  },
  watch: {
    value(val) {
      this.formData = val;
    },
    formData(val) {
      this.$emit('input', val);
    },
    nominations: {
      handler() {
        if (this.hide) return;
        this.$refs.requirementsForm.init();
      },
      deep: true,
    },
    hasChanges(val) {
      this.$emit('hasChanges', val);
    },
  },
  methods: {
    getEventUserRequirements() {
      return this.event.getAttributes({
        'per-page': PER_PAGE.infinity,
      });
    },
    async save() {
      const { nestedMethods } = this;

      const promises = Object.values(nestedMethods).map((method) => method());

      const [r1, r2] = await Promise.all(promises);

      if (!(r1?.error && r2?.error)) {
        this.successCallback();
      }

      return () => null;
    },
    successCallback() {
      this.$emit('updated');
    },
  },
};
</script>
